import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./stores/authStore";
import { ToastProvider } from "./components/ui/Toast";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/layout/DashboardLayout";
import StyleListPage from "./pages/StyleListPage";
import StyleEditPage from "./pages/StyleEditPage";
import BatchCreatePage from "./pages/BatchCreatePage";
import ReleasesPage from "./pages/ReleasesPage";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <ToastProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/styles" replace />} />
          <Route path="styles" element={<StyleListPage />} />
          <Route path="styles/new" element={<StyleEditPage />} />
          <Route path="styles/:id" element={<StyleEditPage />} />
          <Route path="batch" element={<BatchCreatePage />} />
          <Route path="releases" element={<ReleasesPage />} />
        </Route>
      </Routes>
    </ToastProvider>
  );
}
